




import Vue from 'vue'
import { PropValidator, RenderContext } from 'vue/types/options'
import { vuetifyThemeAware } from '@/mixins'
import mixins from 'vue-typed-mixins'

export default mixins(vuetifyThemeAware).extend({
  props: {
    iconName: {
      type: String
    }
  },
  computed: {
    thisClasses (): object {
      const fin: string[] = []
      if (this.isDark) {
        fin.push('theme--dark')
      } else {
        fin.push('theme--light')
      }
      fin.push(this.iconName)
      return fin
    }
  }
})
